module.exports = __webpack_public_path__ + "static/media/logo1.af94fcf8.png";